import { render, staticRenderFns } from "./BreakoutLeave.vue?vue&type=template&id=86a23588&scoped=true&lang=pug"
import script from "./BreakoutLeave.vue?vue&type=script&lang=ts"
export * from "./BreakoutLeave.vue?vue&type=script&lang=ts"
import style0 from "./BreakoutLeave.vue?vue&type=style&index=0&id=86a23588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a23588",
  null
  
)

export default component.exports